import { Box, Center, Flex } from "@chakra-ui/react"

const OptionsSwitcher = ({

    // take in state index
    // have onChange function that (i)
    height, components, activeOption, setActiveOption
} : {
    activeOption : number,
    setActiveOption : (i : number) => void,
    height:number;
    components: React.ReactNode[];

}) => {
    

    const numberOfOptions : number = components.length
    

    return <Flex

        w="100%"
        h={height.toString() + "px"} p='1px'
        minH ={height.toString() + "px"} maxH ={height.toString() + "px"}
        borderRadius='100px'
        bgColor='#F5F7F9'
        pos='relative'


        justifyContent='space-between' alignItems='center'
        boxShadow='0px 2px 4px -2px #00000005'
    >
        <Box
            transition='0.2s ease-out'
            pos='absolute'
            w={`calc(${(100 / numberOfOptions)}% - 15px)`} h={height - 10}
            maxHeight={height - 3} minHeight={height - 7}
            bg="#171C22" 
            borderRadius='44px'
            p="6px 30px 6px 30px"
            left = {`calc(7.5px + ${0 + activeOption * ((0.4 + 100 / numberOfOptions) - (numberOfOptions - activeOption)/numberOfOptions)}%)`}
            ///left = {(15)/2 +  (activeOption) * (containerWidth - (numberOfOptions - activeOption)/numberOfOptions)}
        />  
        {components.map((component, index) => {
            return (<Center key={index} w={`${100 / numberOfOptions}%`} h={`${height}px`} left={`${index * (100 / numberOfOptions)}%`} pos='absolute' cursor='pointer' onClick={() => (activeOption == index) ? {} : setActiveOption(index)}>
                {component}
            </Center>)
        })}
    </Flex>
}

export default OptionsSwitcher;